import React, { useEffect, useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import AppCostEstimator from "./AppCostEstimator";

/**
 * Shell matches {@link ../IdeaValidator/IdeaValidatorModal.jsx} for consistent free-tool UX.
 */
export default function AppCostEstimatorModal({ open, onOpenChange, page }) {
  const [instanceKey, setInstanceKey] = useState(0);

  useEffect(() => {
    if (!open) return;
    setInstanceKey((k) => k + 1);
  }, [open]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="p-0 max-w-3xl w-[95vw] max-h-[90vh] overflow-y-auto overflow-x-hidden bg-[#060b14] border border-white/10">
        <div className="w-full max-w-[680px] mx-auto px-5 sm:px-6 py-8 pb-10">
          <AppCostEstimator key={instanceKey} page={page} variant="modal" />
        </div>
      </DialogContent>
    </Dialog>
  );
}
